import { createFileRoute, notFound } from "@tanstack/react-router";

import { cmsPageHead, cmsPageHeaders } from "@/routing/cmsPageRoute";
import FeaturePage from "./-components/FeaturePage";
import { NotFoundPage } from "@/components/landing/LandingNotFound";
import { featureContent } from "./-components/featureSource";

/**
 * Every feature page. The slug is looked up in the CMS, and one the CMS does
 * not carry answers a real 404 rather than a page saying so: a soft 404 would
 * keep a removed page in the index.
 */
export const Route = createFileRoute("/features/$slug")({
  loader: async ({ params }) => {
    // There is no committed registry behind this, deliberately: see
    // `-components/featureSource.ts` and `content/cmsRegistry.ts`.
    const feature = await featureContent({ data: params.slug });
    if (!feature) {
      throw notFound();
    }
    return feature;
  },
  headers: cmsPageHeaders,
  head: cmsPageHead,
  component: FeatureRoute,
  notFoundComponent: NotFoundPage,
});

function FeatureRoute() {
  return <FeaturePage feature={Route.useLoaderData()} />;
}
